import { apiClient } from '@/api/client'
import type {
  CollectorStats,
  DataSource,
  DataSourceCreatePayload,
  DataSourceListResponse,
  DataSourceUpdatePayload,
  ImportJob,
  ImportJobListResponse,
  ImportLogsResponse,
  ImportStatus,
  SourceType,
} from '@/features/dependencies/types'

export const sourcesApi = {
  async list(params: { offset: number; limit: number; type?: SourceType }): Promise<DataSourceListResponse> {
    const { data } = await apiClient.get<DataSourceListResponse>('/datasources', { params })
    return data
  },
  async create(payload: DataSourceCreatePayload): Promise<DataSource> {
    const { data } = await apiClient.post<DataSource>('/datasources', payload)
    return data
  },
  async update(sourceId: string, payload: DataSourceUpdatePayload): Promise<DataSource> {
    const { data } = await apiClient.put<DataSource>(`/datasources/${sourceId}`, payload)
    return data
  },
  async remove(sourceId: string): Promise<void> {
    await apiClient.delete(`/datasources/${sourceId}`)
  },
}

export const importsApi = {
  async launchRss(sourceId: string, companyId?: string): Promise<ImportJob> {
    const { data } = await apiClient.post<ImportJob>('/imports/rss', {
      source_id: sourceId,
      company_id: companyId,
    })
    return data
  },
  async launchApi(sourceId: string, companyId?: string): Promise<ImportJob> {
    const { data } = await apiClient.post<ImportJob>('/imports/api', {
      source_id: sourceId,
      company_id: companyId,
    })
    return data
  },
  async launchCsv(file: File, sourceId: string, companyId?: string): Promise<ImportJob> {
    const form = new FormData()
    form.append('file', file)
    const { data } = await apiClient.post<ImportJob>('/imports/csv', form, {
      params: { source_id: sourceId, company_id: companyId },
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return data
  },
  async list(params: { offset: number; limit: number; status?: ImportStatus }): Promise<ImportJobListResponse> {
    const { data } = await apiClient.get<ImportJobListResponse>('/imports', { params })
    return data
  },
  async stats(): Promise<CollectorStats> {
    const { data } = await apiClient.get<CollectorStats>('/imports/stats')
    return data
  },
  async logs(jobId: string): Promise<ImportLogsResponse> {
    const { data } = await apiClient.get<ImportLogsResponse>(`/imports/${jobId}/logs`)
    return data
  },
}
